import { Card, Table, TableBody } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DataRow, DateDisplay } from 'app/components';
import clsx from 'clsx';
import React from 'react';
import TitleField from '../TitleField';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    width: '100%',
  },
  table: {
    padding: 0,
  },
}));

const RegtankInfoTable = (props) => {
  const { info = {}, session = {}, className, type } = props;
  const classes = useStyles();
  const renderDate = (date) => {
    if (!date) return '-';

    return <DateDisplay date={date} />;
  };
  return (
    <Card className={clsx(classes.card, className)}>
      <TitleField>Verification Details</TitleField>
      <Table className={classes.table}>
        <TableBody>
          <DataRow name="Request ID" value={info.requestId} />

          <DataRow name="Name" value={info.target_name} />
          {type !== 'upload' && <DataRow name="Email" value={info.target_email} />}
          <DataRow name="Verified Date" value={renderDate(type === 'upload' ? info.createdDate : info.verifyDate)} />

          <DataRow name="Device Type" value={session.deviceType || '-'} />

          <DataRow name="IP Address" value={session.requestIpAddress || '-'} />
        </TableBody>
      </Table>
    </Card>
  );
};

export default RegtankInfoTable;
